import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
	name: 'localizedMediumDate',
	pure: false,
})
export class LocalizedMediumDatePipe implements PipeTransform {
	constructor(private readonly translateService: TranslateService, private readonly datePipe: DatePipe) {}

	transform(value: Date | string | number | null | undefined, pattern = 'medium'): string | null {
		return this.datePipe.transform(value, pattern, undefined, this.translateService.currentLang);
	}
}